
const m = window.require("embercom/objects/inbox/company");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
